import { ArrowSection, Card } from 'components/credits/credit-details/PrecedentDetailsCard/components';
import { CreditType } from 'types/credit';
import { Precedent } from 'types/precedent';
import RequiredCredentialsSection from 'components/credits/credit-details/RequiredCredentialsSection';
import SubjectsSection from 'components/credits/credit-details/SubjectsSection';
import { getPrecedentAltText } from 'utils/aria';
import useFormSchema from 'hooks/use-form-schema';
import { useMemo } from 'react';
import useTranslation from 'hooks/use-translation';

type Props = {
  precedent: Precedent;
};

export function PrecedentDetailsCard(props: Props): JSX.Element {
  const { precedent } = props;
  const formSchema = useFormSchema();
  const translation = useTranslation();
  const ariaText = useMemo(() => {
    if (!formSchema || !translation?.institution) {
      return;
    }
    return getPrecedentAltText(precedent, formSchema, translation.institution);
  }, [formSchema, precedent, translation]);
  return (
    <div>
      <div className='sr-only'>{ariaText}</div>
      <Card className='precedent-details-card'>
        <RequiredCredentialsSection requiredCredentials={precedent.requiredCredentials} />
        <ArrowSection />
        <SubjectsSection creditType={CreditType.PRECEDENT} precedent={precedent} />
      </Card>
    </div>
  );
}
